import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { postUser } from '../Api'

export default generateApiAction({
  baseType: Types.USERS.POST,
  api: postUser,
  responseType: RESPONSETYPE.ID
})



// WEBPACK FOOTER //
// ./src/actions/users/PostAction.js